// TODO: URGENT: why are the fonts being imported here? This is totally wrong, it means fonts are being fetched twice in build???
'use client';

import { Montserrat } from 'next/font/google';
import dynamic from 'next/dynamic';

// import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

const LogoIconDynamic = dynamic(() => import('../v2/assets/icons/LogoIcon'), {
  ssr: false,
});
const ButtonDynamic = dynamic(() => import('../v2/components/Button/Button'), {
  ssr: false,
});
const montserrat = Montserrat({
  weight: ['400', '500', '600', '700'],
  subsets: ['latin'],
});
export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // // Log the error to an error reporting service
    // (async () => {
    //   try {
    //     await Sentry.captureException(error, {
    //       tags: {
    //         environment: process.env.NODE_ENV || 'development',
    //       },
    //     });
    //   } catch (sentryError) {
    //     // Fallback to console in case Sentry fails
    //     console.error('Failed to report error to Sentry:', error);
    //   }
    // })();
  }, [error]);
  return (
    <html
      lang="en"
      style={{ fontFamily: `${montserrat.style.fontFamily}, sans-serif` }}
    >
      <body
        style={{ fontFamily: `${montserrat.style.fontFamily}, sans-serif` }}
      >
        <div
          className="vCenterFirst"
          style={{
            textAlign: 'center',
          }}
        >
          <div
            className="vCenter"
            style={{
              width: `100%`,
            }}
          >
            <LogoIconDynamic width={100} height={30} />
            <h2>ERROR</h2>
            <h4>Something Went Wrong.</h4>
            <h4>Let’s Go Home and Try Again!</h4>
            <ButtonDynamic
              label={`Return to Homepage`}
              type={'primary-v2'}
              onClick={() => (window.location.href = '/')}
            />
          </div>
        </div>
      </body>
    </html>
  );
}
